(function() {
  'use strict';
  
  const _ec = document.querySelector("[data-engraving-block]"); if(!_ec) return; const BLOCK_ID = _ec.dataset.engravingBlock;
  const TEXT_FEE_VARIANT_ID = _ec.dataset.textFeeVariantId;
  const HANDWRITTEN_FEE_VARIANT_ID = _ec.dataset.handwrittenFeeVariantId;
  const TEXT_FEE_CENTS = parseInt(_ec.dataset.textFeeAmount,10)||0;
  const HANDWRITTEN_FEE_CENTS = parseInt(_ec.dataset.handwrittenFeeAmount,10)||0;
  const TEXT_FEE_FORMATTED = '$' + (_ec.dataset.textFeeDollars || '0');
  const HANDWRITTEN_FEE_FORMATTED = '$' + (_ec.dataset.handwrittenFeeDollars || '0');
  const MAX_CHARS = parseInt(_ec.dataset.maxCharacters,10)||20;
  
  function initEngravingBlock() {
    const container = _ec;
    if (!container) return;
    
    // Find the product form - specifically target the add-to-cart form
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                        container.closest('form[action*="/cart/add"]') ||
                        container.closest('.product__details')?.querySelector('form[action*="/cart/add"]') ||
                        document.querySelector('form[action*="/cart/add"]:not(.installment)');
    
    if (!productForm) {
      return;
    }
    
    
    // Elements
    const typeRadios = container.querySelectorAll('.engraving-block__type-radio');
    const textPanel = container.querySelector('[data-engraving-panel="text"]');
    const handwrittenPanel = container.querySelector('[data-engraving-panel="handwritten"]');
    const fontSelect = container.querySelector('select[id^="engravingFont"]');
    const textInput = container.querySelector('input[id^="engravingText"]');
    const charCurrent = container.querySelector('.engraving-block__char-current');
    const textPreview = container.querySelector('[data-preview]');
    const previewText = container.querySelector('.engraving-block__preview-text');
    const fileInput = container.querySelector('[data-engraving-file]');
    const uploadZone = container.querySelector('[data-upload-zone]');
    const filePreview = container.querySelector('[data-file-preview]');
    const fileName = container.querySelector('.engraving-block__file-name');
    const removeFileBtn = container.querySelector('[data-remove-file]');
    const feeNotice = container.querySelector('.engraving-block__fee-notice');
    const feeText = container.querySelector('.engraving-block__fee-text');
    const feeAmount = container.querySelector('.engraving-block__fee-amount');
    const selectedTypeDisplay = container.querySelector('.engraving-block__selected-type');
    const textError = container.querySelector('.engraving-block__text-error');
    const handwrittenError = container.querySelector('.engraving-block__handwritten-error');
    
    // State
    let currentType = '';
    let uploadedFileData = null;
    
    // Price container for live updates
    const priceContainer = document.querySelector('.product__price, .price, [data-price]');
    
    // ============================================================
    // UTILITY FUNCTIONS
    // ============================================================
    
    function upsertHiddenProperty(name, value) {
      const inputName = 'properties[' + name + ']';
      // Use attribute selector that handles special characters
      let input = productForm.querySelector('input[name="' + inputName.replace(/"/g, '\\"') + '"]');
      if (!input) {
        // Also try finding by iterating (more reliable)
        const inputs = productForm.querySelectorAll('input[type="hidden"]');
        for (const inp of inputs) {
          if (inp.name === inputName) {
            input = inp;
            break;
          }
        }
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        productForm.appendChild(input);
      }
      input.value = value;
    }
    
    function removeHiddenProperty(name) {
      const inputName = 'properties[' + name + ']';
      const inputs = productForm.querySelectorAll('input[type="hidden"]');
      for (const input of inputs) {
        if (input.name === inputName) {
          input.remove();
          break;
        }
      }
    }
    
    function clearAllEngravingProperties() {
      removeHiddenProperty('Engraving Type');
      removeHiddenProperty('Engraving Font');
      removeHiddenProperty('Engraving Text');
      removeHiddenProperty('Engraving File');
      removeHiddenProperty('Engraving Fee');
    }
    
    function setError(panel, show) {
      if (panel === 'text') {
        textError.hidden = !show;
        if (show) {
          container.classList.add('has-error');
        }
      } else if (panel === 'handwritten') {
        handwrittenError.hidden = !show;
        uploadZone?.classList.toggle('has-error', show);
        if (show) {
          container.classList.add('has-error');
        }
      }
      if (!show) {
        container.classList.remove('has-error');
      }
    }
    
    function updateDisplayedPrice(addAmount) {
      if (!priceContainer) return;
      
      const priceSpan = priceContainer.querySelector('.price__item--current, .price__item, .price-item--regular, .price__number');
      if (!priceSpan) return;
      
      // Initialize shared fee state if not exists
      if (!window._productFeeState) {
        window._productFeeState = {};
      }
      
      const productId = productForm.id || 'default';
      if (!window._productFeeState[productId]) {
        // Get the TRUE original price from the current display
        const priceText = priceSpan.textContent.replace(/[^0-9.]/g, '');
        let originalPrice = parseFloat(priceText) || 0;
        
        // If ring-size already stored an original price, use that
        if (priceSpan.dataset.originalPrice) {
          originalPrice = parseFloat(priceSpan.dataset.originalPrice);
        }
        
        window._productFeeState[productId] = {
          originalPrice: originalPrice,
          quarterSizeFee: 0,
          engravingFee: 0
        };
      }
      
      const state = window._productFeeState[productId];
      
      // Update engraving fee in state
      state.engravingFee = addAmount / 100;
      
      // Check if quarter-size fee is active (read from hidden input)
      const quarterSizeFeeInput = productForm.querySelector('input[name="properties[Quarter-size fee]"]');
      if (quarterSizeFeeInput && quarterSizeFeeInput.value) {
        const feeMatch = quarterSizeFeeInput.value.match(/[\d.]+/);
        if (feeMatch) {
          state.quarterSizeFee = parseFloat(feeMatch[0]) || 0;
        }
      } else {
        state.quarterSizeFee = 0;
      }
      
      // Calculate total price
      const newPrice = state.originalPrice + state.quarterSizeFee + state.engravingFee;
      
      // Format with currency
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      
      priceSpan.textContent = formatter.format(newPrice);
      
      // Dispatch event so ring-size-selector knows about the change
      document.dispatchEvent(new CustomEvent('engravingFeeChanged', {
        detail: { productId: productId, engravingFee: state.engravingFee }
      }));
    }
    
    function resetDisplayedPrice() {
      if (!priceContainer) return;
      
      const priceSpan = priceContainer.querySelector('.price__item--current, .price__item, .price-item--regular, .price__number');
      if (!priceSpan) return;
      
      const productId = productForm.id || 'default';
      
      if (window._productFeeState && window._productFeeState[productId]) {
        const state = window._productFeeState[productId];
        
        // Clear engraving fee
        state.engravingFee = 0;
        
        // Check if quarter-size fee is still active
        const quarterSizeFeeInput = productForm.querySelector('input[name="properties[Quarter-size fee]"]');
        if (quarterSizeFeeInput && quarterSizeFeeInput.value) {
          const feeMatch = quarterSizeFeeInput.value.match(/[\d.]+/);
          if (feeMatch) {
            state.quarterSizeFee = parseFloat(feeMatch[0]) || 0;
          }
        } else {
          state.quarterSizeFee = 0;
        }
        
        const newPrice = state.originalPrice + state.quarterSizeFee;
        
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        
        priceSpan.textContent = formatter.format(newPrice);
        
        // Dispatch event
        document.dispatchEvent(new CustomEvent('engravingFeeChanged', {
          detail: { productId: productId, engravingFee: 0 }
        }));
      } else {
        // Fallback: use originalPrice data attribute
        const basePrice = parseFloat(priceSpan.dataset.originalPrice) || 0;
        if (basePrice > 0) {
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          });
          priceSpan.textContent = formatter.format(basePrice);
        }
      }
    }
    
    function showFeeNotice(type) {
      if (!type) {
        feeNotice.hidden = true;
        return;
      }
      
      feeNotice.hidden = false;
      
      if (type === 'text') {
        feeText.textContent = 'Text engraving includes a ';
        feeAmount.textContent = TEXT_FEE_FORMATTED;
      } else {
        feeText.textContent = 'Handwritten engraving includes a ';
        feeAmount.textContent = HANDWRITTEN_FEE_FORMATTED;
      }
    }
    
    function getFontClass(fontValue) {
      switch (fontValue) {
        case 'Bookman Classic': return 'font-bookman';
        case 'Bulletin Typewriter': return 'font-bulletin';
        case 'Script MT Bold': return 'font-script';
        default: return '';
      }
    }
    
    // ============================================================
    // FILE UPLOAD HANDLING
    // ============================================================
    
    function handleFileSelect(file) {
      if (!file) return;
      
      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'image/heic'];
      const ext = file.name.split('.').pop().toLowerCase();
      const validExts = ['jpg', 'jpeg', 'png', 'pdf', 'heic'];
      
      if (!validTypes.includes(file.type) && !validExts.includes(ext)) {
        alert('Please upload a JPG, PNG, PDF, or HEIC file.');
        return;
      }
      
      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        alert('File size must be under 10MB.');
        return;
      }
      
      // Store file data
      uploadedFileData = file;
      
      // Update UI
      fileName.textContent = file.name;
      filePreview.hidden = false;
      uploadZone.classList.add('has-file');
      setError('handwritten', false);
      
      // Add property immediately
      upsertHiddenProperty('Engraving File', file.name);
    }
    
    function removeFile() {
      uploadedFileData = null;
      fileInput.value = '';
      filePreview.hidden = true;
      uploadZone.classList.remove('has-file');
      removeHiddenProperty('Engraving File');
    }
    
    // ============================================================
    // EVENT HANDLERS
    // ============================================================
    
    function handleTypeChange(e) {
      currentType = e.target.value;
      
      // Clear errors
      setError('text', false);
      setError('handwritten', false);
      
      // Show/hide panels
      textPanel.hidden = currentType !== 'text';
      handwrittenPanel.hidden = currentType !== 'handwritten';
      
      // Update selected type display and add properties immediately
      if (currentType === 'text') {
        selectedTypeDisplay.textContent = 'Text';
        showFeeNotice('text');
        updateDisplayedPrice(TEXT_FEE_CENTS);
        // Add property immediately so Ring Size Selector will include it
        upsertHiddenProperty('Engraving Type', 'Text');
        upsertHiddenProperty('Engraving Fee', TEXT_FEE_FORMATTED);
        removeHiddenProperty('Engraving File');
      } else if (currentType === 'handwritten') {
        selectedTypeDisplay.textContent = 'Handwritten';
        showFeeNotice('handwritten');
        updateDisplayedPrice(HANDWRITTEN_FEE_CENTS);
        // Add property immediately
        upsertHiddenProperty('Engraving Type', 'Handwritten');
        upsertHiddenProperty('Engraving Fee', HANDWRITTEN_FEE_FORMATTED);
        removeHiddenProperty('Engraving Font');
        removeHiddenProperty('Engraving Text');
      } else {
        selectedTypeDisplay.textContent = '';
        showFeeNotice(null);
        resetDisplayedPrice();
        clearAllEngravingProperties();
      }
    }
    
    function handleTextInput(e) {
      const text = e.target.value;
      const len = text.length;
      
      // Update character count
      charCurrent.textContent = len;
      charCurrent.classList.toggle('is-warning', len >= MAX_CHARS * 0.8 && len < MAX_CHARS);
      charCurrent.classList.toggle('is-limit', len >= MAX_CHARS);
      
      // Update preview
      if (text && fontSelect.value) {
        previewText.textContent = text;
        previewText.className = 'engraving-block__preview-text ' + getFontClass(fontSelect.value);
        textPreview.hidden = false;
      } else {
        textPreview.hidden = true;
      }
      
      // Add property immediately
      if (text.trim()) {
        upsertHiddenProperty('Engraving Text', text.trim());
      } else {
        removeHiddenProperty('Engraving Text');
      }
      
      setError('text', false);
    }
    
    function handleFontChange(e) {
      const font = e.target.value;
      if (textInput.value) {
        previewText.className = 'engraving-block__preview-text ' + getFontClass(font);
        textPreview.hidden = false;
      }
      // Add property immediately
      if (font) {
        upsertHiddenProperty('Engraving Font', font);
      }
      setError('text', false);
    }
    
    // Drag and drop handlers
    function handleDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
      uploadZone.classList.add('is-dragover');
    }
    
    function handleDragLeave(e) {
      e.preventDefault();
      e.stopPropagation();
      uploadZone.classList.remove('is-dragover');
    }
    
    function handleDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      uploadZone.classList.remove('is-dragover');
      
      const files = e.dataTransfer?.files;
      if (files && files[0]) {
        handleFileSelect(files[0]);
      }
    }
    
    // ============================================================
    // FORM SUBMISSION
    // ============================================================
    
    async function uploadFileToShopify(file) {
      // For now, we'll base64 encode smaller files and pass as property
      // For production, you'd want to use Shopify's file upload API or a third-party service
      
      return new Promise((resolve, reject) => {
        if (file.size > 2 * 1024 * 1024) {
          // For larger files, just pass the filename - you'll need to handle this server-side
          resolve(`[File: ${file.name}]`);
          return;
        }
        
        const reader = new FileReader();
        reader.onload = () => {
          // Store as data URL for smaller files
          resolve(reader.result);
        };
        reader.onerror = () => reject(new Error('Failed to read file'));
        reader.readAsDataURL(file);
      });
    }
    
    async function handleFormSubmit(e) {
      
      // If no engraving selected, allow normal submission
      if (!currentType) {
        clearAllEngravingProperties();
        return;
      }
      
      // Validate based on type
      if (currentType === 'text') {
        const font = fontSelect.value;
        const text = textInput.value.trim();
        
        if (!font || !text) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setError('text', true);
          if (!font) fontSelect.focus();
          else textInput.focus();
          return;
        }
        
        // Properties already added via handleTextInput/handleFontChange
        // Just ensure they're set
        upsertHiddenProperty('Engraving Type', 'Text');
        upsertHiddenProperty('Engraving Font', font);
        upsertHiddenProperty('Engraving Text', text);
        upsertHiddenProperty('Engraving Fee', TEXT_FEE_FORMATTED);
        
        
      } else if (currentType === 'handwritten') {
        if (!uploadedFileData) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setError('handwritten', true);
          return;
        }
        
        // Properties already added via handleFileSelect
        upsertHiddenProperty('Engraving Type', 'Handwritten');
        upsertHiddenProperty('Engraving File', uploadedFileData.name);
        upsertHiddenProperty('Engraving Fee', HANDWRITTEN_FEE_FORMATTED);
        
      }
      
      // Store the fee info so we can add it after the main cart add
      const feeVariantId = currentType === 'text' ? TEXT_FEE_VARIANT_ID : HANDWRITTEN_FEE_VARIANT_ID;
      const feeType = currentType === 'text' ? 'Text Engraving' : 'Handwritten Engraving';
      
      if (feeVariantId) {
        // Store pending fee info on the container
        container.dataset.pendingFeeVariantId = feeVariantId;
        container.dataset.pendingFeeType = feeType;
      }
      
      // Let the form submit continue (Ring Size Selector will handle it)
      // The fee will be added after via the cart event listener
    }
    
    async function addToCartWithFee(type) {
      const feeVariantId = type === 'text' ? TEXT_FEE_VARIANT_ID : HANDWRITTEN_FEE_VARIANT_ID;
      const feeFormatted = type === 'text' ? TEXT_FEE_FORMATTED : HANDWRITTEN_FEE_FORMATTED;
      
      const mainVariantInput = productForm.querySelector('input[name="id"]');
      if (mainVariantInput) mainVariantInput.disabled = false;
      
      const mainVariantId = mainVariantInput ? parseInt(mainVariantInput.value, 10) : null;
      if (!mainVariantId) {
        alert('Error: Could not determine product variant. Please refresh and try again.');
        return;
      }
      
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      
      try {
        const cartDrawer = document.querySelector('sht-cart-drwr');
        const cartNotification = document.querySelector('sht-cart-noti');
        const cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
        const cartNotiStyle = document.body.getAttribute('data-cart-noti-type');
        
        let sections = [];
        if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
          sections = sections.concat(cartNotification.getSectionsToRender() || []);
        }
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          sections = sections.concat(cartDrawer.getSectionsToRender() || []);
        }
        
        const formData = new FormData(productForm);
        
        if (sections.length) {
          formData.append('sections', sections.map(s => s.id).join(','));
        }
        formData.append('sections_url', window.location.pathname);
        
        const cartAddUrl = window.Shopify?.routes?.root 
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js';
        
        // Add main product
        const addResponse = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        const addResult = await addResponse.json();
        
        if (addResult.status && addResult.status !== 200) {
          throw new Error(addResult.description || 'Failed to add item to cart');
        }
        
        // Render cart drawer/notification
        if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') {
          cartDrawerForm.renderContents(addResult);
        }
        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(addResult, cartNotiStyle === 'popover_notification', productForm.querySelector('[type="submit"]'));
        }
        
        if (cartNotiStyle === 'show_the_cart_drawer' && cartDrawer && typeof cartDrawer.openDrawer === 'function') {
          const messageEl = cartDrawer.querySelector('.js-drawer-message');
          if (messageEl && typeof messageEl.setActiveMessage === 'function') {
            messageEl.setActiveMessage();
          }
          cartDrawer.openDrawer();
        }
        
        // Add fee variant if configured
        if (feeVariantId) {
          const feeProps = {
            'Fee for': type === 'text' ? 'Text Engraving' : 'Handwritten Engraving',
            'Main variant id': String(mainVariantId)
          };
          
          await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json' 
            },
            body: JSON.stringify({ 
              items: [{ 
                id: parseInt(feeVariantId, 10), 
                quantity: quantity, 
                properties: feeProps 
              }] 
            })
          });
          
          // Refresh sections to show updated totals
          const sectionIds = sections.map(s => s.id).filter(Boolean);
          if (sectionIds.length) {
            const refreshUrl = `${window.Shopify?.routes?.root || '/'}?sections=${encodeURIComponent(sectionIds.join(','))}`;
            const refreshResponse = await fetch(refreshUrl, { headers: { 'Accept': 'application/json' } });
            const refreshedSections = await refreshResponse.json();
            
            const payload = Object.assign({}, addResult, { sections: refreshedSections });
            
            if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') {
              cartDrawerForm.renderContents(payload);
            }
            if (cartNotification && typeof cartNotification.renderContents === 'function') {
              cartNotification.renderContents(payload, cartNotiStyle === 'popover_notification', productForm.querySelector('[type="submit"]'));
            }
          }
        }
        
        document.dispatchEvent(new Event('cart:refresh'));
        
      } catch (error) {
        alert('Sorry, there was a problem adding this item to your cart. Please try again.');
      }
    }
    
    // ============================================================
    // BIND EVENTS
    // ============================================================
    
    typeRadios.forEach(radio => {
      radio.addEventListener('change', handleTypeChange);
    });
    
    if (fontSelect) {
      fontSelect.addEventListener('change', handleFontChange);
    }
    
    if (textInput) {
      textInput.addEventListener('input', handleTextInput);
    }
    
    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
        if (e.target.files && e.target.files[0]) {
          handleFileSelect(e.target.files[0]);
        }
      });
    }
    
    if (uploadZone) {
      uploadZone.addEventListener('dragover', handleDragOver);
      uploadZone.addEventListener('dragleave', handleDragLeave);
      uploadZone.addEventListener('drop', handleDrop);
    }
    
    if (removeFileBtn) {
      removeFileBtn.addEventListener('click', removeFile);
    }
    
    productForm.addEventListener('submit', handleFormSubmit, true);
    
    // Listen for Add to Cart button click to add the engraving fee after
    const addToCartBtn = productForm.querySelector('[type="submit"], button[name="add"], .product-form__submit');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        // Only proceed if engraving is selected
        if (!currentType) return;
        
        const feeVariantId = currentType === 'text' ? TEXT_FEE_VARIANT_ID : HANDWRITTEN_FEE_VARIANT_ID;
        const feeType = currentType === 'text' ? 'Text Engraving' : 'Handwritten Engraving';
        
        if (!feeVariantId) return;
        
        // Get the main variant ID
        const mainVariantInput = productForm.querySelector('input[name="id"]');
        const mainVariantId = mainVariantInput ? mainVariantInput.value : null;
        
        if (!mainVariantId) return;
        
        
        // Wait for the main add to cart to complete, then add the fee
        setTimeout(async () => {
          try {
            
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: parseInt(feeVariantId, 10),
                  quantity: 1,
                  properties: {
                    'Fee for': feeType,
                    'Main variant id': String(mainVariantId)
                  }
                }]
              })
            });
            
            if (response.ok) {
              
              // Refresh the cart drawer
              const cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
              if (cartDrawerForm && typeof cartDrawerForm.getSectionsToRender === 'function') {
                const sections = cartDrawerForm.getSectionsToRender();
                const sectionIds = sections.map(s => s.section || s.id).filter(Boolean);
                if (sectionIds.length) {
                  const refreshResponse = await fetch('/?sections=' + sectionIds.join(','));
                  const refreshedSections = await refreshResponse.json();
                  if (typeof cartDrawerForm.renderContents === 'function') {
                    cartDrawerForm.renderContents({ sections: refreshedSections });
                  }
                }
              }
              
              // Also dispatch cart refresh event
              document.dispatchEvent(new Event('cart:refresh'));
            } else {
            }
          } catch (err) {
          }
        }, 1500); // Wait 1.5 seconds for the main add to cart to complete
      });
    }
    
    // Listen for variant changes to reset price
    document.addEventListener('variant:change', function() {
      const priceSpan = priceContainer?.querySelector('.price__item--current, .price__item, .price-item--regular, .price__number');
      if (priceSpan) {
        delete priceSpan.dataset.originalPrice;
      }
      if (currentType) {
        setTimeout(() => {
          updateDisplayedPrice(currentType === 'text' ? TEXT_FEE_CENTS : HANDWRITTEN_FEE_CENTS);
        }, 100);
      }
    });
    
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEngravingBlock);
  } else {
    setTimeout(initEngravingBlock, 100);
  }
})();
